import { render, staticRenderFns } from "./ModalGerenciarVersoes.vue?vue&type=template&id=00e5dba1&scoped=true"
import script from "./ModalGerenciarVersoes.vue?vue&type=script&lang=js"
export * from "./ModalGerenciarVersoes.vue?vue&type=script&lang=js"
import style0 from "./ModalGerenciarVersoes.vue?vue&type=style&index=0&id=00e5dba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e5dba1",
  null
  
)

export default component.exports